/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ order_code: NonNullable<unknown> }} Einvoice_Err_Number_In_UseInputs */

const vi_einvoice_err_number_in_use = /** @type {(inputs: Einvoice_Err_Number_In_UseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Số này đã gắn cho đơn ${i?.order_code}.`)
};

/**

* @param {Einvoice_Err_Number_In_UseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_number_in_use = /** @type {((inputs: Einvoice_Err_Number_In_UseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Number_In_UseInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_number_in_use(inputs)
});